<template>
    <div>
        <div class="row">
            <div class="col-xl-12">


                <div class="row">
                    <!-- start chat users-->
                    <div class="col-xl-3 col-lg-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="media mb-3">
                                    <div>
                                        <a href="javascript: void(0);" class="text-reset font-20">
                                            <i class="mdi mdi-cog-outline"></i>
                                        </a>
                                    </div>
                                </div>
                                <!-- start search box -->
                                <form class="search-bar mb-3">
                                    <div class="position-relative">
                                        <input type="text" class="form-control form-control-light" v-model="filter"
                                            placeholder="Фильтр по имени или IP" />
                                    </div>
                                </form>
                                <!-- end search box -->
                                <!-- users -->
                                <div class="row">
                                    <div class="col">
                                        <simplebar data-simplebar style="max-height: 500px">
                                            <a href="javascript:void(0);" class="text-body"
                                                v-for="(item, index) in filteredTunnels" :key="index"
                                                @click="selectTunnel(item.hash)">
                                                <div class="media p-2"
                                                    v-bind:class="{ selectedItem: selectedTunnel && tunnel.hash == item.hash }">
                                                    <div class="position-relative">
                                                        <span class="tunnel-status"
                                                            :class="{ 'online': item.status === 'online', 'offline': item.status === 'offline' }"></span>
                                                        <img src="/win-icon.png" class="mr-2 rounded-circle" height="42"
                                                            alt="user" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5 class="mt-0 mb-0 font-14">
                                                            <span
                                                                class="float-right text-muted font-weight-normal font-12">{{
                                            item.time }}</span>
                                                            {{ item.name }}
                                                        </h5>
                                                        <p class="mt-1 mb-0 text-muted font-14">

                                                            <span class="w-75">{{ item.ip }}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </simplebar>
                                        <!-- end slimscroll-->
                                    </div>
                                    <!-- End col -->
                                </div>
                                <!-- end users -->
                            </div>
                            <!-- end card-body-->
                        </div>
                        <!-- end card-->
                    </div>


                    <div class="col-xl-9 col-lg-8" v-if="selectedTunnel">
                        <!-- chat area -->
                        <div class="row">
                            <div class="col-xl-9 col-lg-9" v-if="selectedTunnel">
                                <div class="card">
                                    <div class="card-body py-2 px-3 border-bottom border-light">
                                        <div class="media py-1">
                                            <div class="media-body">
                                                <h5 class="mt-0 mb-0 font-15">
                                                    <div v-if="!edit_mode">
                                                        {{ tunnel.name }}
                                                    </div>
                                                    <div v-else>
                                                        <div class="form-group row">
                                                            <div class="col-sm-4">
                                                                <b-form-input :state="newTunnelNameState"
                                                                    v-model="new_tunnel_name"
                                                                    placeholder="Название туннеля"></b-form-input>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </h5>
                                                <p class="mt-1 mb-0 text-muted font-12">
                                                    <small class="mdi mdi-circle text-success"></small> Online
                                                </p>
                                            </div>

                                            <div>

                                                <a href="javascript: void(0);"
                                                    class="text-reset font-19 py-1 px-2 d-inline-block"
                                                    v-b-tooltip.hover title="Edit" @click="edit_mode = true"
                                                    v-if="!edit_mode">
                                                    <i class="fe-edit"></i>
                                                </a>
                                                <a href="javascript: void(0);"
                                                    class="text-reset font-19 py-1 px-2 d-inline-block"
                                                    v-b-tooltip.hover title="Cancel" v-if="edit_mode"
                                                    :disabled="!newTunnelNameState" @click="exitEditMode">
                                                    <i class="fe-rotate-cw"></i>
                                                </a>
                                                <a href="javascript: void(0);"
                                                    class="text-reset font-19 py-1 px-2 d-inline-block"
                                                    v-b-tooltip.hover title="Save" v-if="edit_mode"
                                                    :disabled="!newTunnelNameState" @click="saveTunnelName">
                                                    <i class="fe-save"></i>
                                                </a>
                                                <a v-if="tunnel.status != 'online'" href="javascript: void(0);"
                                                    class="text-reset font-19 py-1 px-2 d-inline-block"
                                                    v-b-tooltip.hover title="Delete Chat">
                                                    <i class="fe-trash-2"></i>
                                                </a>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="text-muted">
                                            <div class="row">
                                                <div class="col-lg-4 col-sm-6">
                                                    <div class="media mt-3">
                                                        <div class="mr-2 align-self-center">
                                                            <i class="ri-hashtag h2 m-0 text-muted"></i>
                                                        </div>
                                                        <div class="media-body overflow-hidden">
                                                            <p class="mb-1">ID</p>
                                                            <h5 class="mt-0 text-truncate">{{ tunnel.hash }}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-sm-6">
                                                    <div class="media mt-3">
                                                        <div class="mr-2 align-self-center">
                                                        </div>
                                                        <div class="media-body overflow-hidden">
                                                            <p class="mb-1">IP</p>
                                                            <h5 class="mt-0 text-truncate">{{ tunnel.ip }}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-sm-6">
                                                    <div class="media mt-3">
                                                        <div class="mr-2 align-self-center">
                                                            <i class="ri-calendar-event-line h2 m-0 text-muted"></i>
                                                        </div>
                                                        <div class="media-body overflow-hidden">
                                                            <p class="mb-1">Активность</p>
                                                            <h5 class="mt-0 text-truncate" v-b-tooltip.hover
                                                                :title="tunnel.last_activity">{{ lastActivityAgo }}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <!-- end card-body -->
                                </div>
                                <!-- end card -->

                            </div>

                            <div class="col-xl-3 col-lg-3">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="media">
                                            <div class="avatar-md mr-3">
                                                <div class="avatar-title bg-light rounded-circle"><img
                                                        src="/_nuxt/assets/images/companies/airbnb.png" alt="logo"
                                                        class="avatar-sm rounded-circle"></div>
                                            </div>
                                            <div class="media-body">
                                                <h4 class="my-1"><a href="javascript:void(0);" class="text-dark">Airbnb
                                                        Inc.</a></h4>
                                                <p class="text-muted text-truncate mb-0"><i
                                                        class="ri-map-pin-line align-bottom mr-1"></i>
                                                    San Francisco, California
                                                </p>
                                            </div>
                                            <div class="dropdown b-dropdown btn-group" id="__BVID__833"><!----><button
                                                    aria-haspopup="menu" aria-expanded="false" type="button"
                                                    class="btn dropdown-toggle btn-black text-body p-0"
                                                    id="__BVID__833__BV_toggle_"><i
                                                        class="mdi mdi-dots-vertical font-20"></i></button>
                                                <ul role="menu" tabindex="-1" class="dropdown-menu dropdown-menu-right"
                                                    aria-labelledby="__BVID__833__BV_toggle_">
                                                    <li role="presentation"><a role="menuitem" href="#" target="_self"
                                                            class="dropdown-item">Action</a></li>
                                                    <li role="presentation"><a role="menuitem" href="#" target="_self"
                                                            class="dropdown-item">Another action</a></li>
                                                    <li role="presentation"><a role="menuitem" href="#" target="_self"
                                                            class="dropdown-item">Something else here</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="text-muted">
                                            <div class="row">
                                                <div class="col-6">
                                                    <div>
                                                        <p class="text-truncate mb-0">Revenue (USD)</p>
                                                        <h5 class="mb-sm-0">260 cr</h5>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div>
                                                        <p class="text-truncate mb-0">Number of employees</p>
                                                        <h5 class="mb-sm-0">3.1k</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end col -->
                            <div class="col-xl-12 col-lg-12">
                                <div class="card">
                                    <div class="card-body">
                                        <h4 class="header-title mb-3">История подключений</h4>
                                        <div class="row align-items-center">
                                            <!-- Table -->
                                            <div class="table-responsive mb-0">
                                                <b-table :busy.sync="isBusy" :items="loadConnections" :fields="fields"
                                                    responsive="sm" :per-page="perPage" :current-page="currentPage"
                                                    ref="connections_table">
                                                    <template #cell(ip)="data">
                                                        {{data.value}} <img style="vertical-align: baseline;" height="15" :src="`/flags/` + data.item.country.toLowerCase() + `.svg`">
                                                    </template>
                                                </b-table>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <div class="dataTables_paginate paging_simple_numbers float-right">
                                                        <ul class="pagination pagination-rounded mb-0">
                                                            <b-pagination v-model="currentPage"
                                                                :total-rows="total_connections"
                                                                :per-page="perPage"></b-pagination>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <!-- end row -->
                                    </div>
                                    <!-- end card-body-->
                                </div>
                                <!-- end card-->
                            </div>
                            <!-- end col-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
        <!-- 
        <div class="row">
     
            <div class="col-xl-5">
                <b-overlay id="overlay-background" :show="projectsAreLoading" variant="white" opacity="0.85" rounded="sm">
                    <div class="card-box">
                        <div class="float-right">
                            <button class="btn btn-light" style="margin-top:-10px;" v-b-modal.new_target_modal>
                                <i class="mdi mdi-plus-circle mr-1"></i>
                                {{ $t('new_target') }}
                            </button>
                        </div>
                        <h4 class="header-title mb-3">{{ $t('targets') }}</h4>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="inbox-widget slimscroll" v-slimscroll style="max-height: 400px;">
                                    <div class="inbox-item" :key="index" v-for="(target, index) in targets"
                                        style="line-height: 40px;">
                                        <router-link :to="{
                                            name: 'target_overview',
                                            params: { hash: target.hash }
                                        }">
                                            <div class="inbox-item-img">
                                                <img src="https://www.gravatar.com/avatar/3b3be63a4c2a439b013787725dfce802?d=identicon"
                                                    class="rounded-circle" alt />
                                            </div>
                                            <p class="inbox-item-author">{{ target.value }}</p>

                                            <p class="inbox-item-date">
                                                <span class="badge badge-light-info lead">{{ target.status }}</span>
                                            </p>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                       
                        </div>
                    </div>
                </b-overlay>
              
            </div>

             <div class="col-xl-7">
                <div class="card-box">
                    <div class="dropdown float-right">
                        <a href="#" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                            aria-expanded="false"></a>
                    </div>
                    <h4 class="header-title mb-3">{{ $t('recent_events') }}</h4>
                    <div class="row">
                        <div class="col-md-12">...</div>
                    </div>
                </div>
            
            </div> 
           
        </div> -->

    </div>
</template>

<script>
import Portlet from "@src/components/Portlet.vue";
import simplebar from 'simplebar-vue';
import axios from 'axios';
import { humanFileSize, timeAgo } from "@src/utils"
import apexchart from 'vue-apexcharts'

const tableData = [
    {
        name: 'Lucinda Stickley',
        position: 'Data Coordiator',
        office: 'Sirnarasa',
        age: 31,
        date: '2018/07/29',
        salary: '$13600'
    }, {
        name: 'Henrietta Carsberg',
        position: 'Data Coordiator',
        office: 'Paninggaran',
        age: 59,
        date: '2019/07/13',
        salary: '$13700'
    }, {
        name: 'Phylys David',
        position: 'Senior Developer',
        office: 'New Glasgow',
        age: 52,
        date: '2019/04/08',
        salary: '$15200'
    }, {
        name: 'Brena Shivell',
        position: 'Graphic Designer',
        office: 'Caen',
        age: 50,
        date: '2018/12/14',
        salary: '$15800'
    }, {
        name: 'Carmon Tuiller',
        position: 'Marketing Assistant',
        office: 'Jiangbei',
        age: 46,
        date: '2019/06/19',
        salary: '$12800'
    }, {
        name: 'Tina Strattan',
        position: 'Account Representative III',
        office: 'São Miguel da Carreira',
        age: 31,
        date: '2019/07/08',
        salary: '$13900'
    }, {
        name: 'Jon Tarbox',
        position: 'Senior Cost Accountant',
        office: 'Ryazhsk',
        age: 61,
        date: '2019/02/22',
        salary: '$16000'
    }, {
        name: 'Carmine Hollibone',
        position: 'Assistant Manager',
        office: 'Punta del Este',
        age: 50,
        date: '2019/04/23',
        salary: '$15000'
    }, {
        name: 'Cora Germann',
        position: 'Automation Specialist III',
        office: 'Heshui',
        age: 47,
        date: '2019/03/27',
        salary: '$11300'
    }, {
        name: 'Dawna Hillyatt',
        position: 'Biostatistician I',
        office: 'Suresnes',
        age: 37,
        date: '2018/12/02',
        salary: '$14800'
    }, {
        name: 'Natty Casini',
        position: 'Senior Developer',
        office: 'Pucallpa',
        age: 31,
        date: '2018/08/19',
        salary: '$11900'
    }, {
        name: 'Vittorio Lauder',
        position: 'Developer II',
        office: 'Tønsberg',
        age: 54,
        date: '2018/12/10',
        salary: '$16200'
    }, {
        name: 'Chery Cardenas',
        position: 'Senior Developer',
        office: 'Santo Tomas',
        age: 26,
        date: '2018/12/07',
        salary: '$11100'
    }, {
        name: 'Hilde McFfaden',
        position: 'Senior Financial Analyst',
        office: 'Cruz',
        age: 43,
        date: '2018/11/05',
        salary: '$14100'
    }
];
export default {
    components: { Portlet, simplebar, apexchart },
    data() {
        return {
            tunnels: [],
            tunnel: {},
            tunnel_stat: [],
            filter: "",

            series: [],
            new_tunnel_name: "",
            edit_mode: false,

            isBusy: false,
            tableData: tableData,
            title: 'Advanced Table',
            loadInterval: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            total_connections: 0,
            filterOn: [],
            sortBy: 'age',
            sortDesc: false,
            connections: [],
            fields: [{
                key: 'start_date',
                sortable: true
            },
            {
                key: 'end_date',
                sortable: true
            },
            {
                key: 'ip',
                // sortable: true
            },
            {
                key: 'proto',
                //sortable: true
            }],
        };
    },
    created() {
        if (this.loadInterval == null)
            this.loadInterval = setInterval(this.loadTunnels, 5000)
    },
    computed: {
        selectedTunnel() {
            return Object.keys(this.tunnel).length != 0
        },
        filteredTunnels() {
            return this.tunnels.filter(t => t.name.toLowerCase().includes(this.filter) || t.ip.toLowerCase().includes(this.filter))
        },
        lastActivityAgo() {
            return timeAgo(this.tunnel.last_activity)
        },
        targetState() {
            return this.target.length > 0 ? true : false;
        },
        rows() {
            return this.tableData.length
        },
        newTunnelNameState() {
            return this.new_tunnel_name.length > 0 ? true : false
        }
    },
    beforeMount() {
        // this.loadProjectInfo();
    },
    mounted() {
        this.loadTunnels();
        this.loadTunnelStat()
    },
    watch: {
        // currentPage:{
        //     handler(){
        //         this.loadConnections()
        //     }
        // },
        tunnel: {
            handler(val, oldVal) {

            },
        }
    },

    methods: {
        loadTunnels() {
            let that = this;
            this.projectsAreLoading = true;
            axios
                .get(`/api/secure/wh/tunnels/list/`)
                .then(response => {
                    this.projectsAreLoading = false;
                    const data = response.data;
                    if (data.error) {
                        throw data.error;
                    }
                    that.tunnels = data.data;
                    if (that.tunnels.length && !this.selectedTunnel) {
                        this.selectTunnel(that.tunnels[0].hash)
                    }
                })
                .catch(e => {
                    throw new Error(e);
                });
        },
        selectTunnel(hash) {
            this.currentPage = 1
            for (let t of this.tunnels) {
                if (t.hash == hash) {
                    this.tunnel = t
                    this.new_tunnel_name = this.tunnel.name
                    this.edit_mode = false
                    break
                }
            }
            // this.connectionsProxy()
            // this.loadConnections()
            this.$refs.connections_table.refresh()
        },

        loadTunnelStat() {
            let that = this;
            axios
                .get(`/api/secure/wh/tunnels/graph/`)
                .then(response => {
                    const data = response.data;
                    if (data.error) {
                        throw data.error;
                    }
                    let series = []
                    for (let r of data.data) {
                        if (series.some(s => s.hash === r.hash)) {
                            for (let sid in series) {
                                if (series[sid].hash == r.hash) {
                                    series[sid].data.push([r.date, r.used])
                                    break
                                }
                            }
                        } else {
                            series.push({ hash: r.hash, name: r.name, data: [[r.date, r.used]] })
                        }

                        // if (tunnels.hasOwnProperty(r.hash)) {
                        //     tunnels[r.hash]
                        // } else {
                        //     tunnels[r.hash] = [[r.date, r.used]];
                        // }
                    }
                    // for (let ok of Object.keys(tunnels)) {
                    //     series.push({ name: tunnels[ok], data: tunnels[ok] })
                    // }
                    // console.log('tunnels=', tunnels)
                    that.series = series
                    // console.log('series:', that.series)
                })
                .catch(e => {
                    throw new Error(e);
                });
        },
        saveTunnelName() {
            axios
                .post(`/api/secure/wh/tunnels/update/?tunnel=${this.tunnel.hash}&action=new_name`, { name: this.new_tunnel_name })
                .then(response => {
                    this.tunnel.name = this.new_tunnel_name
                    this.edit_mode = false
                })
                .catch(e => {
                    this.edit_mode = false
                    throw new Error(e);
                });
        },
        exitEditMode() {
            this.edit_mode = false
        },

        handleOK(evt) {
            evt.preventDefault();
            this.handleAddTarget();
        },
        handleAddTarget() {
            if (!this.checkFormValidity()) {
                return;
            }
            this.addNewTarget();
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity();
            return valid;
        },

        async loadConnections() {
            let that = this
            // this.isBusy = false
            let records = []
            try {
                // that.isBusy = false
                const response = await axios.get(`/api/secure/wh/tunnels/connections/?tunnel=${this.tunnel.hash}&page=${this.currentPage}&size=${this.perPage}`)
                that.total_connections = response.data.total
                records = response.data.records
            }
            catch (error) {
                // this.isBusy = false
            }
            // this.$refs.connections_table.refresh()
            this.connections = records
            return records
        }

    }
};
</script>
<style>
.selectedItem {
    background: #f1f5f7;
}

.tunnel-status {
    position: absolute;
    height: 13px;
    width: 13px;
    background-color: #ced4da;
    border: 2.5px solid #fff;
    border-radius: 50%;
    bottom: 0;
    left: 30px;
}

.tunnel-status.online {
    background-color: #1abc9c;
}

.tunnel-status.offline {
    background-color: #f1556c;
}
</style>